import { db } from '@/main';

export default {
  namespaced: true,

  actions: {
    getNotyfications ({ commit }, ruta) {
      return db.ref(ruta).once('value');
    },
    getRef ({ commit }, data) {
      return db.ref(data);
    },
    update ({ commit }, data) {
      return db.ref().update(data);
    },
    updateData ({ commit }, el, data) {
      return db.ref(el).update(data);
    },

    detachEvent (state, data) {
      db.ref(data).off();
    }
  }
};
